import React, { useState } from "react";
import axios from "axios";
import { useTransportContext } from "../../hooks/useTransportContext";
import "./TransportHome.css";
import TransportNavbar from "../../components/TransportNavbar";

const TransportHome = () => {
  const { transports, loading, error, setTransports } = useTransportContext();
  const [selectedTransport, setSelectedTransport] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  // Haal de transportgebruiker op uit localStorage
  const transportUser = JSON.parse(localStorage.getItem("transportUser"));
  const shippingAgent = transportUser?.company || "Onbekend";

  // ✅ Transporten filteren op zoekterm
  const filteredTransports = transports
    .filter(
      (t) =>
        t.Delivered_By_Shipping_Agent !== true &&
        (
          t.No.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.Customer_Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.Status.toLowerCase().includes(searchTerm.toLowerCase())
        )
    )
    .sort((a, b) => new Date(a.Delivery_Date) - new Date(b.Delivery_Date));

  const markAsDelivered = async (transport) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/driver-transports/deliver`,
        {
          no: transport.No,
          companyId: transport.Customer_No,     // 👈 meegeven aan backend
          customerAgreed: true,
        }
      );
  
      // frontend direct updaten: rit uit lijst halen
      setTransports((prev) => prev.filter((t) => t.No !== transport.No));
      setSelectedTransport(null);
    } catch (error) {
      console.error("❌ Fout bij melden van levering:", error);
    }
  };

  const handleDownload = async (no) => {
    if (!no) {
      alert("Geen transportnummer ontvangen.");
      return;
    }
  
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/transports/pdf/${no}`,
        {
          responseType: "blob",
          headers: {
            "X-Cultivation-Company": "WPK", // ✅ hardcoded zoals je wil
          },
        }
      );
  
      const fileURL = URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
  
      const newTab = window.open(fileURL, "_blank");
  
      if (!newTab) {
        alert("Pop-ups zijn geblokkeerd. Sta pop-ups toe om de PDF te openen.");
        return;
      }
  
      newTab.onload = () => {
        newTab.document.title = `${no}.pdf`;
      };
  
      setTimeout(() => {
        window.URL.revokeObjectURL(fileURL);
      }, 5000);
    } catch (error) {
      console.error("Fout bij ophalen van PDF:", error);
      alert("Er is een fout opgetreden bij het ophalen van de afleverbon.");
    }
  };
  

  return (
    <div className="transport-home">
      <TransportNavbar />
      <h1>🚛 Transport melden - {shippingAgent}</h1>

      {/* ✅ Zoekbalk */}
      <input
        type="text"
        placeholder="🔍 Zoek transport..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />

      {loading && <p>Laden...</p>}
      {error && <p className="error">⚠️ {error}</p>}
      {filteredTransports.length === 0 && !loading && <p>Geen transporten beschikbaar.</p>}

      <ul className="transport-list">
        {filteredTransports.map((transport) => (
          <li key={transport.No} onClick={() => setSelectedTransport(transport)}>
            <span>{transport.No} - {transport.Description} - {transport.Vehicle_Code} - {transport.Delivery_Date} {transport.Delivery_Time.slice(0,5)}</span>
          </li>
        ))}
      </ul>

      {selectedTransport && (
        <div className="modal">
          <div className="modal-content">
            <h2>Transport Details</h2>
            <p><strong>Nr:</strong> {selectedTransport.No}</p>
            <button className="download-button" onClick={() => handleDownload(selectedTransport.No)}>
              Afleverbon
            </button>
            <p><strong>Transport Nr:</strong> {selectedTransport.Transport_No}</p>
            <p><strong>Klant:</strong><br />
             {selectedTransport.Customer_Name}</p>
            
             <p>
              <strong>Adres:</strong><br />
              {/* Naam + code (alleen als shipping address bekend is) */}
              {selectedTransport.Ship_to_Name && (
                <>
                  {selectedTransport.Ship_to_Name}
                  {selectedTransport.Ship_to_Code && (
                    <> — {selectedTransport.Ship_to_Code}</>
                  )}
                  <br />
                </>
              )}

              {/* Straat + huisnummer */}
              {selectedTransport.Delivery_Address && (
                <>
                  {selectedTransport.Delivery_Address}
                  <br />
                </>
              )}

              {/* Postcode + plaats */}
              {(selectedTransport.Delivery_Post_Code || selectedTransport.Delivery_City) && (
                <>
                  {selectedTransport.Delivery_Post_Code || ""}{" "}
                  {selectedTransport.Delivery_City || ""}<br />
                  {selectedTransport.Delivery_Country || ""}
                </>
              )}
            </p>

            <p><strong>Status:</strong> {selectedTransport.Status}</p>
            <p><strong>Datum:</strong> {new Date(selectedTransport.Delivery_Date).toLocaleDateString("nl-NL")}</p>
            <p><strong>Tijd:</strong> {selectedTransport.Delivery_Time.slice(0,5)}</p>

            <button className="close-button" onClick={() => setSelectedTransport(null)}>
              Sluiten
            </button>
            <button
              className="mark-button"
              onClick={() => markAsDelivered(selectedTransport)}
            >
              Meld als Geleverd
            </button>               
          </div>
        </div>
      )}
    </div>
  );
};

export default TransportHome;
